import { render, staticRenderFns } from "./refundDetail.vue?vue&type=template&id=4a267cf1&scoped=true"
import script from "./refundDetail.vue?vue&type=script&lang=js"
export * from "./refundDetail.vue?vue&type=script&lang=js"
import style0 from "./refundDetail.vue?vue&type=style&index=0&id=4a267cf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a267cf1",
  null
  
)

export default component.exports